import { InvoiceInjection } from "./invoice-injection.interface";

export class InvoiceInjectionModel implements InvoiceInjection {
    public Number: string;

    public PrimaryReference: string;

    public SecondaryReference: string;

    public IssuedAt: Date | string | '';

    public DueDate: Date | string | '';

    public RecipientEntityId: number | null;

    public AmountTaxExcluded: number | null;

    public AmountTaxIncluded: number | null;

    public Currency: string;

    public IsReverseFactoring: boolean;

    public SupplierSiren: string;

    public SupplierSiret: string;

    public SupplierCompanyName: string;

    public SupplierVatNumber: string;

    public SupplierRcsNumber: string;

    public ProjectManagerName: string;

    public SupplierEvaluaCompanyName: string;

    public SupplierSageErpCode: string;

    public SupplierMdmId: number | null;

    public Source: string;

    public OcrDate: Date | string | '';

    public ImportDate: Date | string | '';

    public InvoiceDocuwareDocumentId: number | null;

    public InvoiceDocuwareDocumentFileName: string;

    public ImportMissingInvoiceNumberDocumentId: number | null;
}
